// Regra de DRE por pagamento (espelha o enum TipoDrePagamento do Backend).
// Mantém os mesmos valores numéricos para evitar números mágicos espalhados pelos componentes.
export const TIPO_DRE_PAGAMENTO = Object.freeze({
  TITULOS_POR_DATA_PAGAMENTO: 1, // Títulos — valor recebido
  BAIXAS_POR_VALOR_RECEBIDO: 2, // Baixas — valor recebido (PADRÃO/fallback)
  BAIXAS_POR_VALOR_DA_CONTA: 3, // Baixas — Valor da Conta
});

// Padrão e fallback quando o backend não retorna valor.
export const TIPO_DRE_PAGAMENTO_DEFAULT = TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_RECEBIDO;

// Opções exibidas no select "Regra DRE por pagamento".
export const TIPO_DRE_PAGAMENTO_OPTIONS = [
  { value: TIPO_DRE_PAGAMENTO.TITULOS_POR_DATA_PAGAMENTO, label: "Títulos — valor recebido" },
  { value: TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_RECEBIDO, label: "Baixas — valor recebido" },
  { value: TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_DA_CONTA, label: "Baixas — Valor da Conta" },
];

// Explicação dinâmica apresentada abaixo do select.
const TIPO_DRE_PAGAMENTO_DESCRICOES = {
  [TIPO_DRE_PAGAMENTO.TITULOS_POR_DATA_PAGAMENTO]:
    "Considera os títulos a pagar e a receber, utilizando o valor recebido ou pago e a data de pagamento registrada no título.",
  [TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_RECEBIDO]:
    "Considera cada baixa pelo valor efetivamente recebido ou pago. Descontos, juros e multas não são apresentados separadamente.",
  [TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_DA_CONTA]:
    "Considera cada baixa pelo valor original da conta. Descontos, juros e multas são recompostos e apresentados separadamente no DRE.",
};

export function getTipoDrePagamentoDescricao(value) {
  return (
    TIPO_DRE_PAGAMENTO_DESCRICOES[value] ??
    TIPO_DRE_PAGAMENTO_DESCRICOES[TIPO_DRE_PAGAMENTO_DEFAULT]
  );
}

// Normaliza o valor vindo do backend (ou ausente) para uma das três regras válidas.
export function normalizeTipoDrePagamento(value) {
  const n = Number(value);
  return n === TIPO_DRE_PAGAMENTO.TITULOS_POR_DATA_PAGAMENTO ||
    n === TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_RECEBIDO ||
    n === TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_DA_CONTA
    ? n
    : TIPO_DRE_PAGAMENTO_DEFAULT;
}
